module.exports = __webpack_public_path__ + "img/Slovenija.7a8b13b2.png";